module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("I dedicate this book to my beautiful, loving wife, Doina, who stood by me in the worst of times, always encouraging me to remain faithful to God in spite of the repercussions brought to our family; and to my beloved children, Kristina and Alin.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0